import { useRouter } from 'next/router';

import { useAtom, useAtomValue } from 'jotai';

import useTranslation from '@/utils/hooks/translation/useTranslation';

// libs
import { promotedPostCommentsOptions } from '@/lib/giveawayPicker/options';
// Constants
import { giveawayPickerUrl } from '@/lib/urls/giveawayPickerUrl';

import Button from '@/components/base/Button';
import CompoundBanner from '@/components/base/InfoBanner/CompoundBanner';
// Components
import { Select } from '@/components/base/Select/SelectComponent';
// Atoms
import { optionsAtom } from '@/components/pages/giveaway-picker/Atoms/OptionsAtoms';
import { selectedPostAtom } from '@/components/pages/giveaway-picker/Atoms/postsAtoms';
import { TitleOption } from '@/components/pages/giveaway-picker/OptionsWrapper/components/TitleOption';

const optionsPromotedPostComments = promotedPostCommentsOptions;

export const PromotedPostComments = () => {
    const { t } = useTranslation('giveaway_picker');
    const router = useRouter();
    const [options, setOptions] = useAtom(optionsAtom);
    const post = useAtomValue(selectedPostAtom);
    const errorMessage = t('options.promoted_posts_warning');

    const selectedOption =
        optionsPromotedPostComments.find((option) => option.value === options.paid_comments) ||
        optionsPromotedPostComments[0];

    return (
        <div className="flex flex-col gap-3" data-testid="promoted-post-comments">
            <TitleOption
                title={t('options.comments_on_promoted_posts')}
                subtitle={t('options.include_entry_comments')}
            />
            <Select
                className="w-full"
                selected={selectedOption}
                setSelected={(option) => {
                    setOptions((prev) => ({
                        ...prev,
                        paid_comments: option.value
                    }));
                }}
                options={optionsPromotedPostComments}
            />
            {options.paid_comments && post.is_promoted === false ? (
                <CompoundBanner type="warning">
                    <CompoundBanner.Icon />
                    <CompoundBanner.Content message={errorMessage} />
                    <Button
                        variant="orange200"
                        size="sm"
                        onClick={() => {
                            router.push(giveawayPickerUrl);
                        }}>
                        {t('reauth')}
                    </Button>
                </CompoundBanner>
            ) : null}
        </div>
    );
};
